import type { HTMLChakraProps, ThemingProps } from "@chakra-ui/react";
import {
    chakra,
    forwardRef,
    omitThemingProps,
    StylesProvider,
    useMultiStyleConfig,
} from "@chakra-ui/react";
import { cx } from "../../../utils/chakra";

export interface SurfaceProps extends HTMLChakraProps<"div">, ThemingProps<"Surface"> {}

export const Surface = forwardRef<SurfaceProps, "div">(
    ({ variant, size, colorScheme, ...props }, ref) => {
        const styles = useMultiStyleConfig("Surface", { variant, size, colorScheme });
        const ownProps = omitThemingProps(props);

        return (
            <StylesProvider value={styles}>
                <chakra.div
                    ref={ref}
                    {...ownProps}
                    className={cx("chakra-surface", props.className)}
                    __css={styles.root}
                />
            </StylesProvider>
        );
    }
);
